// Generated by Copilot
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { FormContainer, TextFieldElement, useForm } from 'react-hook-form-mui';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from '@mui/material';

import { CREATE_POUR_TYPE_SCHEMA } from '@barboxx/admin-utils';
import Api from '@barboxx/api';
import { PourType } from '@barboxx/models';

interface Props {
    open: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export const CreatePourTypeDialog = ({ onClose, onSuccess, open }: Props) => {
    const notifications = useNotifications();

    const formContext = useForm<PourType.CreateRequest>({
        resolver: yupResolver(CREATE_POUR_TYPE_SCHEMA),
        defaultValues: {},
    });
    const mutateCreatePourType = useMutation({
        mutationKey: ['pourType'],
        mutationFn: (data: PourType.CreateRequest) =>
            Api.Servings.PourType.postPourType(data),
    });

    const onSubmit = async (values: PourType.CreateRequest) => {
        return mutateCreatePourType
            .mutateAsync(values)
            .then(({ data }) => {
                notifications.show(`Created ${values.name}!`, {
                    severity: 'success',
                });
                onClose();
                onSuccess();
            })
            .catch(e => {
                notifications.show('Error creating pour type!', {
                    severity: 'error',
                });
            });
    };

    const handleCancelCreate = () => {
        formContext.reset();
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
        >
            <DialogTitle id="alert-dialog-title">Create Pour Type</DialogTitle>
            <FormContainer onSuccess={onSubmit} formContext={formContext}>
                <DialogContent
                    sx={{ gap: 2, display: 'flex', flexDirection: 'column' }}
                >
                    <TextFieldElement label="Name" name="name" fullWidth />
                    <TextFieldElement
                        label="Description"
                        name="description"
                        fullWidth
                    />
                    <TextFieldElement
                        fullWidth
                        name="defaultVolumeOz"
                        label="Volume (oz)"
                        type="number"
                        slotProps={{
                            htmlInput: {
                                min: 0,
                                max: 1000,
                                step: 0.1,
                            },
                        }}
                    />
                    <TextFieldElement
                        fullWidth
                        name="defaultVolumeMl"
                        label="Volume (ml)"
                        type="number"
                        slotProps={{
                            htmlInput: {
                                min: 0,
                                max: 10000,
                                step: 1,
                            },
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelCreate} color="inherit">
                        Cancel
                    </Button>

                    <Button
                        color="primary"
                        variant="contained"
                        loading={formContext.formState.isSubmitting}
                        type="submit"
                        disabled={formContext.formState.isSubmitting}
                    >
                        Create
                    </Button>
                </DialogActions>
            </FormContainer>
        </Dialog>
    );
};
